import React from "react";
import TopicPreviewComponent from "../components/topics/preview";

const TopicPreviewPage = () => {
  return (
    <>
      <TopicPreviewComponent />
    </>
  );
};

export default TopicPreviewPage;
